// @ts-nocheck - Freshchat widget is not properly added to the window object
export const open = () => window.fcWidget?.open();
export const setOnClose = (onClose: () => void) => window.fcWidget?.on('widget:closed', onClose);
